import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, KImageURL, DefaultImage } from "../GlobalScript";
import Cookies from 'js-cookie';
import Select from 'react-select';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";

export default function Item() {

    const navigate = useNavigate();
    const location = useLocation();
    const { vehicle, model, year, item } = location.state || {};

    const [loading, setLoading] = useState(true);
    const [quantity, setQuantity] = useState(1);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [pop, setPop] = useState(false);

    useEffect(() => {
        document.title = 'K-Dealer - Item';
    });

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            #root > div > div {
                background-color: #fff;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style); // Clean up when unmounting
        };
    });

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    //Leave modal code just in case we add one later to this page
    const handleDetailsModalShow = () => {
        setShowDetailsModal(true);
    }
    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'quantity') {
            setQuantity(value);
        }
    }

    const returnCatalog = () => {
        navigate('/catalog', { state: { vehicle: vehicle, model: model, year: year } });
    }

    const addToCart = () => {
        //Add to cart
    }

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="mb-3">
                    <Col sm={12} className="">
                        <Card className="green-border-bottom">
                            <Card.Body>
                                <Row>
                                    <Col sm={4} className="border-right">
                                        <Row>
                                            <Col sm={8}>
                                                <h1 className="heading"><span className="green-text">2025</span> KLX230R</h1>
                                            </Col>
                                            <Col sm={4}>
                                                <img src="https://content2.kawasaki.com/ContentStorage/KMC/ProductTrimGroup/60/264cd617-a42e-480c-af87-33282b85b988.png?w=300&v=01" alt="vehicle" className="category-header-image" />
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col sm={8}>
                                        <Row>
                                            <Col sm={9}>
                                                <h4 className="heading mt-3">MAINTENANCE TOOLS & PARTS</h4>
                                            </Col>
                                           
                                            <Col sm={3}>
                                                <Button variant="secondary" onClick={returnCatalog}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    CHANGE VEHICLE
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <p href="/catalog/item#" onClick={returnCatalog} className="black-text heading uppercase clickable underline">
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-left-fill" viewBox="0 0 16 16" role="presentation" style={{ transform: 'rotate(180deg)' }}>
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            Back to Catalog
                        </p>
                    </Col>
                </Row>

                <Row className="mt-5 item-detail-item">
                    <Col sm={4}>
                        <Row>
                            <Col sm={12} className="text-center mb-4">
                                <img src={KImageURL(item.itemNumber, item.img)}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = DefaultImage;
                                    }}
                                    alt={item.descr} className="item-detail-image" />
                            </Col>
                            <Col sm={12} className="text-center mt-3">
                                <a href="/catalog/item#warranty" className="black-text">Warranty Statement</a>
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={8}>
                        <Row>
                            {item &&
                                <>
                                    <Row className="border-bottom">
                                        <Col sm={9}>
                                            <h2 className="heading">{item.descr}</h2>
                                            <p className="smaller-text">#{item.itemNumber}</p>
                                            <p className="smaller-text">Suggested Retail Price: {item.retailPrice}</p>
                                        </Col>

                                        <Col sm={3}>
                                            <h2 className="heading catalog-item-price">{item.price}</h2>
                                        </Col>
                                    </Row>

                                    <Row className="border-bottom">
                                        <Col sm={4}>
                                            <Row>
                                                <Col>
                                                    <h3 className="heading mt-3">Quantity</h3>
                                                </Col>
                                                <Col>
                                                    <Form.Select aria-label="Quantity" value={quantity} onChange={handleChange} name="quantity" className="mt-3 mb-3">
                                                        <option value={1}>1</option>
                                                        <option value={2}>2</option>
                                                        <option value={3}>3</option>
                                                        <option value={4}>4</option>
                                                        <option value={5}>5</option>
                                                    </Form.Select>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col sm={{ offset: 4, size: 4}}>
                                            <DropdownButton
                                                variant="outline-dark"
                                                title="All Compatible Models"
                                                className="mt-3 mb-2 dropdown-info"
                                            >
                                                <Dropdown.ItemText><span className="bold">Eliminator 125:</span> 2009 2007 2006 2005 2004 2002</Dropdown.ItemText>
                                                <Dropdown.ItemText><span className="bold">KAZE HIT:</span> 2011 2010 2007 2006</Dropdown.ItemText>
                                                <Dropdown.ItemText><span className="bold">KFX 450R:</span> 2014 2013 2012 2011 2010 2009 2008</Dropdown.ItemText>
                                            </DropdownButton>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm={12}>
                                            <Button variant="primary" onClick={addToCart} className="mt-3">
                                                + ADD TO CART
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </Row>
                    </Col>
                </Row>

            </Container>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <FooterDealer />           
        </>
    );
}